import { useEffect, useRef, useState } from "react";

export default function useMinDelay(active, minMs = 900) {
  const [visible, setVisible] = useState(active);
  const startTs = useRef(0);

  useEffect(() => {
    let t;
    if (active) {
      startTs.current = performance.now();
      setVisible(true);
    } else {
      const elapsed = performance.now() - (startTs.current || 0);
      const remain = Math.max(0, minMs - elapsed);
      t = setTimeout(() => setVisible(false), remain);
    }
    return () => t && clearTimeout(t);
  }, [active, minMs]);

  return visible;
}
